<ng-container *ngIf="item.decision == 'Sell'">
    <mat-card>
        <h2>Sale Info</h2>

        <div class="sell-amounts">
            <div>
                <div class="label">Price</div>
                <ap-money [outline]="true" [(amount)]="item.sell.price" (amountChange)="save()"></ap-money>
            </div>

            <div>
                <div class="label">Lowest</div>
                <ap-money [outline]="true" [(amount)]="item.sell.lowest" (amountChange)="save()"></ap-money>
            </div>

            <!-- <div>

                <mat-form-field class="example-form-field">
                    <mat-label>Clearable input</mat-label>
                    <input matInput type="text" [(ngModel)]="item.sell.quantity">
                    <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
            </div> -->
        </div>
    </mat-card>
</ng-container>